import React, { useEffect, useState } from "react";
import Sidebar from "../../../components/Sidebar";
import TrendDashboardPage from "./TrendDashboardPage";
import { useAuth } from "../../../firebase/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import LanguageSwitcher from "../../../components/LanguageSwitcher";
import { BouncingDots } from "../AiChat/components";

function DashboardPage() {
  const { currentUser, getUserProfile, isAuthReady } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const profile = getUserProfile();

  const getLangFromUrl = () => {
    const params = new URLSearchParams(location.search);
    return params.get("lang") === "zh" ? "zh" : "en";
  };

  const [language, setLanguage] = useState(getLangFromUrl());

  useEffect(() => {
    if (!currentUser) {
      navigate({ pathname: "/login", search: `?lang=${language}` });
    }
  }, [currentUser, navigate, language]);

  if (!currentUser || !profile || !isAuthReady) {
    return (
      <div className="flex h-screen bg-slate-100 dark:bg-dashboard-bg text-black dark:text-white font-sans">
        <LanguageSwitcher language={language} setLanguage={setLanguage} />
        <div className="flex-1 flex flex-col gap-8 items-center justify-center -mt-36">
          <div className="flex flex-col gap-4 items-center text-center">
            <div className="flex items-center gap-2">
              <BouncingDots />
              <span className="text-orange-500 text-lg font-semibold">
                {language === "zh" ? "正在加載數據..." : "Loading data..."}
              </span>
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              {language === "zh"
                ? "請稍候，正在為您準備個人資料面板。"
                : "Please wait while we prepare your profile panel."}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-screen overflow-y-auto flex">
      <Sidebar />
{/* Role-based dashboards are parked for now. To re-enable, restore the
          PMDashboardPage / AdminDashboardPage imports and `hasRole` from useAuth:
          {hasRole && hasRole("admin_panel.access") ? (
            <AdminDashboardPage />
          ) : hasRole && hasRole("analytics.read") ? (
            <PMDashboardPage />
          ) : ( */}
      <TrendDashboardPage />
      {/* )} */}
    </div>
  );
}

export default DashboardPage;
